function switchVariantContent(variantId) {
  const variantBlocks = document.querySelectorAll('[data-variant-block]');
  
  variantBlocks.forEach(block => {
    const variantContents = block.querySelectorAll('[data-variant-id]');
    
    variantContents.forEach(content => {
      const contentVariantId = parseInt(content.dataset.variantId);
      
      if (contentVariantId === variantId) {
        content.style.display = 'block';
        setTimeout(() => {
          content.style.opacity = '1';
          content.style.transform = 'translateY(0)';
        }, 10);
      } else {
        content.style.opacity = '0';
        content.style.transform = 'translateY(-10px)';
        setTimeout(() => {
          content.style.display = 'none';
        }, 300);
      }
    });
  });
}

function filterMediaByVariant(variant) {
  const mediaGallery = document.querySelector('media-gallery');
  if (!mediaGallery) return;

  const allMediaItems = mediaGallery.querySelectorAll('li[data-media-id]');
  const thumbnailItems = mediaGallery.querySelectorAll('.thumbnail-list__item');
  
  let visibleMediaCount = 0;
  const visibleMediaIds = [];
  
  allMediaItems.forEach((item) => {
    const mediaIdAttr = item.dataset.mediaId;
    if (!mediaIdAttr) return;
    
    const mediaIdParts = mediaIdAttr.split('-');
    const mediaId = mediaIdParts[mediaIdParts.length - 1];
    
    const img = item.querySelector('img');
    if (!img) return;
    
    const shouldShow = shouldShowMedia(img, variant);
    
    if (shouldShow) {
      item.style.display = '';
      item.classList.remove('hidden');
      visibleMediaIds.push(mediaIdAttr);
      visibleMediaCount++;
    } else {
      item.style.display = 'none';
      item.classList.add('hidden');
    }
  });
  
  thumbnailItems.forEach((thumbnail) => {
    const targetId = thumbnail.dataset.target;
    if (visibleMediaIds.includes(targetId)) {
      thumbnail.style.display = '';
      thumbnail.classList.remove('hidden');
    } else {
      thumbnail.style.display = 'none';
      thumbnail.classList.add('hidden');
    }
  });
  
  updateSliderCounter(visibleMediaCount);
}

function shouldShowMedia(img, variant) {
  const imgAlt = (img.alt || '').toLowerCase();
  const imgSrc = img.src;
  const variantTitle = variant.title.toLowerCase();
  
  if (imgAlt.includes(variantTitle)) {
    return true;
  }
  
  if (variant.options && Array.isArray(variant.options)) {
    for (const option of variant.options) {
      if (option && imgAlt.includes(option.toLowerCase())) {
        return true;
      }
    }
  }
  
  if (variant.featured_image && imgSrc.includes(variant.featured_image.src)) {
    return true;
  }
  
  if (variant.featured_media && variant.featured_media.src && imgSrc.includes(variant.featured_media.src)) {
    return true;
  }
  
  return false;
}

function updateSliderCounter(count) {
  const counterTotal = document.querySelector('.slider-counter--total');
  if (counterTotal) {
    counterTotal.textContent = count;
  }
}

if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe === 'function') {
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const { variant } = event.data;
    if (!variant) return;
    
    switchVariantContent(variant.id);
    filterMediaByVariant(variant);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const productInfo = document.querySelector('product-info');
  if (!productInfo) return;
  
  const variantSelect = productInfo.querySelector('variant-selects');
  if (variantSelect) {
    const selectedVariantData = variantSelect.querySelector('[data-selected-variant]');
    if (selectedVariantData) {
      try {
        const variant = JSON.parse(selectedVariantData.innerHTML);
        if (variant && variant.id) {
          switchVariantContent(variant.id);
          filterMediaByVariant(variant);
        }
      } catch (e) {
        console.error('Error parsing variant data:', e);
      }
    }
  }
});
